import React from 'react';
import { getRoleClassName } from '../utils/roles';
import './_Buttons.css';
import './_UserTiles.css';

const StaffDetailModal = ({ staff, onClose, onEdit, onDelete, canManage }) => {
    if (!staff) {
        return null;
    }

    const handleDelete = () => {
        if (window.confirm('Are you sure you want to delete this staff member?')) {
            onDelete();
        }
    };


    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>X</button>
                <h2>
                    {staff.first_name} {staff.middle_name && `${staff.middle_name} `}{staff.last_name}
                </h2>
                <p><strong>Email:</strong> {staff.email}</p>
                {staff.phone && <p><strong>Phone:</strong> {staff.phone}</p>}
                {staff.description && <p><strong>Description:</strong> {staff.description}</p>}
                <p><strong>Sex:</strong> {staff.sex.name}</p>
                <div className="roles-container">
                    {staff.roles.map(role => (
                        <div key={role.id} className={`role-tile ${getRoleClassName(role.name)}`}>{role.name}</div>
                    ))}
                </div>
                {canManage && (
                    <>
                        <div className='actions-centered'>
                            <button onClick={onEdit} className="cancel-button text-button">Edit</button>
                            <button onClick={handleDelete} className="submit-button text-button">Delete</button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default StaffDetailModal;